export function extractS3ObjectName(fullName: string) {
  let arraySplitOnDelimiter = fullName.split('-');
  arraySplitOnDelimiter.shift();
  return arraySplitOnDelimiter.join('-');
}
